module.exports = __webpack_public_path__ + "static/img/qiepian00.3c72ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian00.png
// module id = pbO/
// module chunks = 2